import * as yup from "yup";
import StringSchema from "yup/lib/string";

import {
  maxLengthMessage,
  peselMessage,
  requiredMessage,
} from "../validationMessages";
import {
  peselValidatorOptional as peselValidatorOptionalRegex,
  peselValidator as peselValidatorRegex,
} from "../validationRegex";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 11;

export const peselValidator = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .matches(peselValidatorOptionalRegex, {
    message: peselMessage,
    excludeEmptyString: true,
  });
export const peselValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage)
  .matches(peselValidatorRegex, peselMessage);
export const peselValidatorRelatedRequired = (field: string): StringSchema =>
  trimmedString.when(`$${field}`, (lackOfPeselField: string | undefined) => {
    return yup.lazy((val: string | undefined) => {
      if (
        (lackOfPeselField === undefined && val === undefined) ||
        lackOfPeselField === "true"
      ) {
        return yup.string().notRequired();
      }

      return peselValidatorRequired;
    });
  });

export const peselValidatorNotRequired = trimmedString.notRequired();
